import { render, staticRenderFns } from "./ReprocessBatch.vue?vue&type=template&id=f4f52cda"
import script from "./ReprocessBatch.vue?vue&type=script&lang=ts"
export * from "./ReprocessBatch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports